package com.exura.components.snackbar

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.flow.receiveAsFlow

@Composable
internal fun SnackbarEmitter(): Channel<SnackbarMessage> {
    val eventEmitter = remember { Channel<SnackbarMessage>() }
    val event: SnackbarMessage? by eventEmitter
        .receiveAsFlow()
        .collectAsState(null)

    event?.let {
        Snackbar(it)
    }

    return eventEmitter
}

@Composable
internal fun Snackbar(): SnackbarController {
    val eventEmitter = remember { Channel<SnackbarMessage>() }
    val event: SnackbarMessage? by eventEmitter
        .receiveAsFlow()
        .collectAsState(null)

    event?.let {
        Snackbar(it)
    }

    return remember(eventEmitter) {
        ChannelSnackbarController(eventEmitter)
    }
}
